module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iIzA3ODkzMCIgZD0iTTUxMiAwdjUxMkwwIDB6Ii8+CiAgPHBhdGggZmlsbD0iI2ZjZGQwOSIgZD0iTTAgMGw1MTIgNTEySDB6Ii8+CiAgPHBhdGggZmlsbD0iI2RhMTIxYSIgZD0iTTI1NiAxODAuMTQ4bDQ0LjU4NSAxMzcuMjE3TDE4My44NiAyMzIuNTZoMTQ0LjI4bC0xMTYuNzI1IDg0LjgwNXoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/gf.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/gf.svg
// module chunks = 0